import { apiCall } from "utils/apiClient";

export const createAccessRequest = (payload) =>
  apiCall({
    endpoint: "admin/user-access/request",
    method: "POST",
    data: payload,
  });

export const listAccessRequests = () =>
  apiCall({
    endpoint: "admin/user-access/requests",
    method: "GET",
  });

export const updateAccessRequestStatus = (requestId, status, payload = {}) =>
  apiCall({
    endpoint: `admin/user-access/request/${requestId}/status`,
    method: "PUT",
    data: { status, ...payload },
  });

export const impersonationLogin = (payload) =>
  apiCall({
    endpoint: "admin/user-access/create-login-grant",
    method: "POST",
    data: payload,
  });

export const impersonationLogout = (payload = {}) =>
  apiCall({
    endpoint: "admin/user-access/logout",
    method: "POST",
    data: payload,
  });

export const validateAccessSession = () =>
  apiCall({
    endpoint: "admin/user-access/session/validate",
    method: "GET",
  });

export const listAccessLogs = () =>
  apiCall({
    endpoint: "admin/user-access/logs",
    method: "GET",
  });

export const listRequestLogs = (requestId) =>
  apiCall({
    endpoint: `admin/user-access/request/${requestId}/logs`,
    method: "GET",
  });

export const listCustomersForAccess = (payload = {}) =>
  apiCall({
    endpoint: "customer/getCustomer",
    method: "POST",
    data: payload,
  });
